import request from '@/axios'

//获取国家字典
export const getCountryDictApi = () => {
  return request.get({ url: '/ors-system/dict/country/list' })
}

export const getCurrentUserApi = async () => {
  return request.get({ url: '/ors-system/user/getInfo' })
}
//获取当前导入进度
export const getImportProgressApi = async (taskId) => {
  return request.get({ url: `/ors-system/upload/${taskId}` })
}
//通过字典type获取字典列表
export const getDictListApi = (data) => {
  return request.post({
    url: `/ors-system/dict/listByPage`,
    params: {
      pageNum: 1,
      pageSize: 1000
    },
    data: data
  })
}
//获取二段换单仓库
export const getWarehouseApi = () => {
  return request.post({
    url: '/ors-system/dict/listByPage',
    params: {
      pageNum: 1,
      pageSize: 1000
    },
    data: {
      dictType: 'order_logistics_exchange_waybill_enum'
    }
  })
}

//获取物流产品国家
export const getLogisticsProductCountryApi = () => {
  return request.get({
    url: '/ors-system/dict/listByEnum',
    params: { type: 'LOGISTICS_PRODUCT_COUNTRY_SERVICE' },
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
//获取物流产品 物流商
export const getLogisticsProductLogisticsApi = () => {
  return request.get({
    url: '/ors-system/dict/listByEnum',
    params: { type: 'LOGISTICS_LOGISTICS_CODE_SERVICE' },
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
//获取中转仓编码
export const getTransferWarehouseApi = () => {
  return request.get({
    url: '/ors-system/dict/listByEnum',
    params: { type: 'LOGISTICS_LOGISTICS_EXCHANGE_WAYBILL_ENUM' },
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
